import React from "react";

const TelecomMediaLayout = () => {
    return (
        <div className="bg-white">

            {/* ================= HERO ================= */}
            <section className="bg-[#9acd6a]">
                <div className="max-w-7xl mx-auto px-6 py-24 grid md:grid-cols-2 gap-12 items-center">
                    <div>
                        <span className="text-sm uppercase opacity-80">Industries</span>
                        <h1 className="text-4xl md:text-5xl font-bold mt-4 text-gray-900">
                            Telecom & Media
                        </h1>
                        <p className="mt-6 max-w-xl text-gray-800">
                            Empowering telecom and media enterprises to modernize networks,
                            enhance customer experiences, and unlock new digital revenue streams.
                        </p>
                    </div>

                    <img
                        src="https://images.unsplash.com/photo-1581091012184-7f1b3e7b48c1"
                        alt="Telecom Infrastructure"
                        className="rounded-xl shadow-xl"
                    />
                </div>
            </section>

            {/* ================= INTRO ================= */}
            <section className="py-20">
                <div className="max-w-5xl mx-auto px-6 space-y-4 text-gray-700">
                    <p>
                        Telecom and media organizations face increasing pressure to deliver
                        always-on connectivity, immersive digital experiences, and agile
                        service innovation.
                    </p>
                    <p>
                        We help providers re-architect networks, modernize operations, and
                        leverage AI-driven insights to remain competitive in a rapidly evolving
                        digital ecosystem.
                    </p>
                </div>
            </section>

            {/* ================= NETWORK & TELECOM ================= */}
            <section className="py-20">
                <div className="max-w-7xl mx-auto px-6 grid md:grid-cols-3 gap-10">
                    <div className="md:col-span-2">
                        <h2 className="text-3xl font-bold mb-4">
                            Network and Telecom Transformation
                        </h2>
                        <p className="text-gray-700">
                            Modernize core networks and enable cloud-native, software-defined,
                            and 5G-ready architectures to support future growth and scalability.
                        </p>

                        <button className="mt-6 bg-orange-500 text-white px-6 py-3 rounded-md">
                            Learn more about our offerings
                        </button>
                    </div>

                    <div className="bg-[#020617] text-white rounded-xl p-6">
                        <h4 className="font-semibold mb-4">Our Offerings</h4>
                        <ul className="space-y-2 text-sm text-gray-300">
                            <li>• Network Modernization</li>
                            <li>• Cloud & Edge Computing</li>
                            <li>• OSS/BSS Transformation</li>
                            <li>• Data & Analytics</li>
                            <li>• AI-Driven Automation</li>
                        </ul>
                    </div>
                </div>
            </section>

            {/* ================= SERVICE LINES ================= */}
            <section className="py-20 bg-gray-50">
                <div className="max-w-7xl mx-auto px-6">
                    <h2 className="text-3xl font-bold mb-10">
                        Leveraging the Strength of Our Service Lines
                    </h2>

                    <div className="grid md:grid-cols-3 gap-6">
                        {[
                            "Application Modernization",
                            "Cloud & Distributed Edge",
                            "Network Performance Optimization",
                            "Customer Experience Platforms",
                            "Security & Compliance",
                            "Intelligent Automation",
                            "Enterprise Integration",
                            "Data Engineering",
                            "AI-Powered Insights",
                        ].map((item) => (
                            <div
                                key={item}
                                className="bg-white rounded-xl shadow-sm p-6 text-sm font-medium"
                            >
                                {item}
                            </div>
                        ))}
                    </div>
                </div>
            </section>

            {/* ================= CLIENT SUCCESS ================= */}
            <section className="py-20 bg-[#020617] text-white">
                <div className="max-w-7xl mx-auto px-6">
                    <h2 className="text-3xl font-bold mb-10">Client Success</h2>

                    <div className="grid md:grid-cols-3 gap-6">
                        {[1, 2, 3].map((i) => (
                            <div key={i} className="bg-white text-black rounded-xl p-6">
                                <p className="font-medium">
                                    Helping a global telecom provider accelerate digital
                                    transformation and customer engagement.
                                </p>
                                <button className="mt-4 text-orange-600 text-sm">
                                    Read the story →
                                </button>
                            </div>
                        ))}
                    </div>
                </div>
            </section>

            {/* ================= WHY US ================= */}
            <section className="py-20 bg-[#fde8db]">
                <div className="max-w-7xl mx-auto px-6 grid md:grid-cols-3 gap-8">
                    <div>
                        <h4 className="font-semibold mb-2">Robust Execution</h4>
                        <p className="text-sm">
                            Proven delivery frameworks for large-scale telecom programs.
                        </p>
                    </div>
                    <div>
                        <h4 className="font-semibold mb-2">Domain Leadership</h4>
                        <p className="text-sm">
                            Deep expertise across telecom, media, and digital ecosystems.
                        </p>
                    </div>
                    <div>
                        <h4 className="font-semibold mb-2">Technology Innovation</h4>
                        <p className="text-sm">
                            Accelerating transformation using cloud, AI, and automation.
                        </p>
                    </div>
                </div>
            </section>

            {/* ================= PARTNERS ================= */}
            <section className="py-20 bg-gray-50">
                <div className="max-w-7xl mx-auto px-6">
                    <h2 className="text-3xl font-bold mb-8">Our Partner Ecosystem</h2>

                    <div className="grid grid-cols-2 md:grid-cols-5 gap-6">
                        {["AWS", "Google Cloud", "Microsoft", "Salesforce", "Appian"].map(
                            (p) => (
                                <div
                                    key={p}
                                    className="bg-white rounded-lg p-4 text-center shadow-sm text-sm font-medium"
                                >
                                    {p}
                                </div>
                            )
                        )}
                    </div>
                </div>
            </section>

            {/* ================= CONTACT ================= */}
            <section className="py-20 bg-white">
                <div className="max-w-7xl mx-auto px-6">
                    <h2 className="text-3xl font-bold mb-8">Contact us</h2>

                    <form className="grid md:grid-cols-2 gap-6">
                        <input className="border p-3 rounded" placeholder="First name" />
                        <input className="border p-3 rounded" placeholder="Last name" />
                        <input className="border p-3 rounded" placeholder="Work email" />
                        <input className="border p-3 rounded" placeholder="Company" />
                        <textarea
                            className="border p-3 rounded md:col-span-2"
                            rows="4"
                            placeholder="How can we help?"
                        />
                        <button className="bg-orange-500 text-white px-6 py-3 rounded-md">
                            Submit
                        </button>
                    </form>
                </div>
            </section>

        </div>
    );
};

export default TelecomMediaLayout;
